import { useAtom } from 'jotai';
import { Button, Modal } from '@/components';
import {
    bookingErrorAtom,
    hasBlockingConsultationAtom,
} from '@/features/booking/shared/model/bookingState';
import { useUrlState } from '@/features/booking/shared/model/useUrlState';
import { R } from '@/features/booking/resources/Texts.resx';

export const BookingErrorModal = () => {
    const [errorMessage, setErrorMessage] = useAtom(bookingErrorAtom);
    const [blockingConsultation, setBlockingConsultation] = useAtom(
        hasBlockingConsultationAtom,
    );
    const { urlState } = useUrlState();

    const handleClose = () => {
        // we detected a blocking consultation when bootstrapping the booking app
        if (!urlState?.page) {
            window.location.href = '/';
        }

        setErrorMessage('');
        setBlockingConsultation(false);
    };

    if (!errorMessage && !blockingConsultation) return null;

    return (
        <Modal
            title={blockingConsultation ? R.YouHaveBlockingConsultation : null}
            hideCloseButton={true}
            onClose={handleClose}
        >
            <div className="text-secondary flex flex-col gap-5">
                {errorMessage}

                {!!blockingConsultation && (
                    <div>
                        <p>{R.BlockingConsultationMessage}</p>

                        <p>
                            {R.BlockingConsultationMessage2}
                            <a
                                href="/consultations"
                                className="text-action-orange ml-1 underline-offset-2 hover:underline"
                            >
                                {R.TheConsultationList}.
                            </a>
                        </p>
                    </div>
                )}

                <div className="flex justify-end">
                    <Button
                        variant="primary"
                        onClick={handleClose}
                        className="ns:w-auto mt-2 w-full min-w-44"
                    >
                        {R.Ok}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
